import {
  GraphItem,
  GroupType,
  isComponentGraphEdgeModel,
  isNode,
  GraphGroup,
  isCollapsibleGroup,
  ComponentGraphGroup,
} from '@ardoq/graph';
import { BaseNode as OldGraphNode } from 'graph/BaseNode';
import { Edge as OldGraphEdge } from 'graph/edge';
import type {
  GraphInputMode,
  IModelItem,
  ItemClickedEventArgs,
} from '@ardoq/yfiles';

import { dispatchAction } from '@ardoq/rxbeach';
import { selectComponent } from 'streams/components/ComponentActions';
import { selectReference } from 'streams/references/ReferenceActions';
import { openWorkspace } from 'streams/workspaces/actions';
import { componentGraphSelectionChanged } from '@ardoq/component-selection';
import { dataModelId } from 'tabview/graphComponent/graphComponentUtil';

const getModelId = ({ tag }: IModelItem) => {
  if (tag instanceof GraphItem) {
    return tag.modelId;
  }
  if (tag instanceof OldGraphNode || tag instanceof OldGraphEdge) {
    return dataModelId(tag);
  }
  return '';
};

const itemIsComponent = ({ tag }: IModelItem) =>
  (isNode(tag) ||
    tag instanceof OldGraphNode ||
    tag instanceof GraphGroup ||
    tag instanceof ComponentGraphGroup) &&
  tag.isComponent();

const itemIsReference = ({ tag }: IModelItem) =>
  isComponentGraphEdgeModel(tag) || tag instanceof OldGraphEdge;

const itemIsWorkspace = ({ tag }: IModelItem) =>
  isCollapsibleGroup(tag) && tag.type === GroupType.WORKSPACE;

/** @returns true if navigation occurs. */
const navigate = (item: IModelItem) => {
  const modelId = getModelId(item);

  if (itemIsComponent(item)) {
    // clear selection and set context component
    dispatchAction(componentGraphSelectionChanged({ graphSelection: [] }));
    dispatchAction(selectComponent({ cid: modelId }));
    return true;
  }

  if (itemIsReference(item)) {
    dispatchAction(selectReference({ cid: modelId }));
    return true;
  }

  if (itemIsWorkspace(item)) {
    dispatchAction(
      openWorkspace({ workspaceId: modelId, keepCurrentContext: false })
    );
    return true;
  }
  return false;
};

const graphItemDoubleClickedListener = (
  e: ItemClickedEventArgs<IModelItem>,
  _: GraphInputMode
) => (e.handled = navigate(e.item));

export { graphItemDoubleClickedListener, getModelId, itemIsComponent };
